import { useGetSettingsQuery } from "./settingsApiSlice"
import Setting from "./Setting"
import useAuth from "../../hooks/useAuth"
import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'

const SettingsList = () => {
    useTitle('techSettings: Settings List')

    const { username, isManager, isAdmin } = useAuth()

    const {
        data: settings,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetSettingsQuery('settingsList', {
        pollingInterval: 15000,
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })

    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess) {
        const { ids, entities } = settings

        let filteredIds
        if (isManager || isAdmin) {
            filteredIds = [...ids]
        } else {
            filteredIds = ids.filter(settingId => entities[settingId].username === username)
        }

        const tableContent = ids?.length && filteredIds.map(settingId => <Setting key={settingId} settingId={settingId} />)

        content = (
            <table className="table table--settings">
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th setting__title">Title</th>
                        <th scope="col" className="table__th setting__status">Username</th>
                        <th scope="col" className="table__th setting__created">Created</th>
                        <th scope="col" className="table__th setting__updated">Updated</th>
                        <th scope="col" className="table__th setting__username">Update By</th>
                        <th scope="col" className="table__th setting__edit">Edit</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
        )
    }

    return content
}
export default SettingsList